"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconBase = require("../IconBase");

var _utils = require("../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var iconBase = {
  width: 12,
  height: 12
};

var Check = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Check, _PureComponent);

  function Check() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Check.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        color = _this$props.color,
        size = _this$props.size,
        block = _this$props.block;
    var newSize = (0, _utils.calcIconSize)(iconBase, size);
    return _react2.default.createElement(_IconBase.Svg, {
      name: "check",
      size: newSize,
      block: block,
      viewBox: "0 0 12 12"
    }, _react2.default.createElement("path", {
      d: "M10.8 4.4L9.4 3L5.4 7L3.4 5L2 6.4L5.4 9.8L10.8 4.4Z",
      fill: color
    }));
  };

  return Check;
}(_react.PureComponent);

Check.defaultProps = {
  color: 'currentColor',
  size: 16,
  block: false
};
Check.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number,
  block: _propTypes2.default.bool
};
exports.default = Check;